import React from "react";
import { Form } from "react-bootstrap";

function Customform({ children, className = "", onSubmit }) {
  return (
    <Form className={className} onSubmit={onSubmit}>
      {children}
    </Form>
  );
}

export default Customform;
